import { render } from "./CountryDistributionChart.vue?vue&type=template&id=47334151&scoped=true"
import script from "./CountryDistributionChart.vue?vue&type=script&lang=js"
export * from "./CountryDistributionChart.vue?vue&type=script&lang=js"

import "./CountryDistributionChart.vue?vue&type=style&index=0&id=47334151&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47334151"]])

export default __exports__